<div class="desktopBasket">
  <button
    (click)="handleClick()"
    [attr.aria-label]="'basket_aria_go_to_basket' | i18next"
    class="desktopButton"
  >
    {{ 'basket_desktop_button_title' | i18next }}
  </button>

  <button class="basket" (click)="handleClick()">
    <span class="number">{{ basketItemsTotal }}</span>
    <i class="fa fa-shopping-cart" aria-hidden="true"></i>
  </button>
</div>

<div class="mobileBasket">
  <button
    class="basket"
    [attr.aria-label]="'basket_aria_go_to_basket' | i18next"
    (click)="handleClick()"
  >
    <span class="number">{{ basketItemsTotal }}</span>
    <i class="fa fa-shopping-cart" aria-hidden="true"></i>
    {{ 'basket' | i18next }}
    <span class="sr-only">
      {{ 'basket_sr_items' | i18next: { count: basketItemsTotal } }}
    </span>
  </button>
</div>
